import { Component, OnInit } from '@angular/core';
import { Role } from '../shared/models/role';
import { NgForm } from '@angular/forms';
import * as _ from "lodash-es";
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'pps-role-form',
  templateUrl: './role-form.component.html',
  styles: [
  ],
})
export class RoleFormComponent implements OnInit {
  role: Role = null;
  oldRole: Role = null;

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _dialogConfig: DynamicDialogConfig
  ) { }

  ngOnInit(): void {
    this.role = this._dialogConfig.data.role;
  }

  save(form: NgForm){
    if (form.invalid){
      return false;
    }

    if (_.isEqual(this.oldRole, this.role)){
      this._dialogRef.close();
    }else{
      this._dialogRef.close(this.role);
    }
  }

  cancel(){
    this._dialogRef.close();
  }

  set Role(role: Role){
    this.role = Object.assign({}, role);
    this.oldRole = role;
  }
  
  isNewRole(){
    return this.role === null || this.role.id === 0;
  }
}
